




























import { store } from "@/store";
import { defineComponent, onMounted, ref, Ref } from "@vue/composition-api";
import axios from "axios";
import { ReleaseNote, ReleaseNotes } from "@/shared/model/release-note.model";

export default defineComponent({
  name: "ReleaseNotes",
  setup() {
    const releaseNotes: Ref<ReleaseNote[]> = ref([]);

    onMounted(() => {
      const currentLanguage = store.getters.currentLanguage;
      axios.get(`release-notes/${currentLanguage}.json`).then(result => {
        const data: ReleaseNotes = result.data;
        const notes: ReleaseNote[] = Object.entries(data)
          .filter(([version, notes]) => notes.newFeatures || notes.improvements || notes.fixes)
          .map(([version, notes]) => ({
            version,
            ...notes
          }));
        notes.sort((a, b) => {
          const aTokens = a.version.split(".").map(Number);
          const bTokens = b.version.split(".").map(Number);
          for (let i = 0; i < Math.max(aTokens.length, bTokens.length); i++) {
            const aToken = aTokens[i] || 0;
            const bToken = bTokens[i] || 0;
            if (aToken !== bToken) {
              return bToken - aToken; // Descending order
            }
          }
          return 0;
        });

        releaseNotes.value = notes;
      });
    });

    return {
      releaseNotes
    };
  }
});
